/* eslint-disable */

import { Box, ButtonBase, Chip, Container, Grid, MenuItem, Select, TextField, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { SearchOutlined, SentimentDissatisfied } from '@material-ui/icons';
import { AccountHeartOutline, ShieldSearch, TicketPercentOutline } from 'mdi-material-ui';
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { useLoader } from '../../../contexts/pharmaceutical-portal/Loader.context';
import { contentsIntegrationService } from '../../../services';
import SurveyPopup from '../SurveyPopUp';
import { IContentIntegration, IPostIntegration, ITagIntegration } from '../common/contracts';

const useStyles = makeStyles({
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    border: '1px solid #eee',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.03)',
      '& img': {
        transform: 'scale(1.1)',
      }
    }
  },
  imageBox: {
    width: '100%',
    height: 'auto',
    maxHeight: '300px',
    overflow: 'hidden',
    position: 'relative',
  },
  image: {
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
    transition: 'transform 0.3s ease',
    maxHeight: '100%',
  },
  title: {
    fontWeight: 'bold',
    color: 'var(--primary-main)',
    marginTop: '8px',
    height: '45px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  content: {
    color: '#556275',
    marginTop: '8px',
    height: '60px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '@media (max-width: 1200px)': {
      fontSize: '0.8rem',
    },
    '@media (max-width: 1100px)': {
      fontSize: '0.7rem',
    },
  },
  buttonBaseContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
    width: '100%',
    height: '100%',
    textDecoration: 'none',
    color: 'inherit',
  }
});

const DashboardPage: React.FC<any> = (): JSX.Element => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const origin = window.location.pathname.includes('/unimed') ? '/unimed' : '';
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("Todas as categorias");
  const [showSurveyPopup, setShowSurveyPopup] = useState(false);
  const [filteredBanners, setFilteredBanners] = useState<IContentIntegration[]>([]);
  const [filteredNews, setFilteredNews] = useState<IPostIntegration[]>([]);
  const [filteredCategories, setFilteredCategories] = useState<ITagIntegration[]>([]);
  const [callApiPost, setCallApiPost] = useState<boolean>(false);
  const [documentId, setDocumentId] = useState<string>("");
  const [url, setUrl] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const { showLoader, hideLoader } = useLoader();

  const { data: banner } = contentsIntegrationService.getContents(true, "banner");
  const { data: notice } = contentsIntegrationService.getPosts(true);
  const { data: tagsResponse } = contentsIntegrationService.getTags();

  useEffect(() => {
    if (tagsResponse?.data?.data) {
      setFilteredCategories(tagsResponse.data.data);
    }
  }, [tagsResponse]);

  useEffect(() => {
    if (notice?.data?.data) {
      setFilteredNews(notice.data.data);
    }
  }, [notice]);

  useEffect(() => {
    if (banner?.data?.data) {
      setFilteredBanners(banner.data.data);
    }
  }, [banner]);
  
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const term = event.target.value.toLowerCase();
    
    setSearchTerm(term);
    filterNews(term, selectedCategory);
  };

  const handleCategoryChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const category = event.target.value as string;
    
    setSelectedCategory(category);
    filterNews(searchTerm, category);
  };

  const filterNews = (term: string, category: string) => {  
    const filtered = notice?.data?.data.filter(news => {
      const matchesSearch =
        news.title.toLowerCase().includes(term) ||
        news.description.toLowerCase().includes(term);

      const matchesCategory =
        category === "Todas as categorias" ||
        news.tags.map(tag => tag.name).includes(category);

    return matchesSearch && matchesCategory;
  }) || [];

  setFilteredNews(filtered);
  };

  useEffect(() => {
    const timer = setTimeout(() => setShowSurveyPopup(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  const {
    data: singlePostData,
    isSuccess,
    error,
  } = contentsIntegrationService.getPosts(callApiPost, documentId);

  useEffect(() => {
    if (callApiPost && isSuccess && singlePostData?.data?.data?.length > 0) {
      const post = singlePostData.data.data[0];
      const htmlContent = post?.body;
      const formattedUrl = url.replace(/\s+/g, "-");
      hideLoader();

      setTimeout(() => {
        history.push({
          pathname: `/panel/contents/${formattedUrl}`,
          state: { htmlContent, title },
        });
      }, 300);

      setCallApiPost(false);
    }

    if (callApiPost && error) {
      console.error("Erro ao buscar post:", error);
      setCallApiPost(false);
    }
  }, [callApiPost, isSuccess, singlePostData, error, history]);

  const handleClick = (news: IPostIntegration) => {
    showLoader();
    try {
      setDocumentId(news.documentId);
      setTitle(news.title);
      setUrl(news.url);
      setCallApiPost(true);
    } catch (error) {
      console.error("Erro ao buscar post filtrado:", error);
    }
  };

  const handleClosePopup = () => {
    setShowSurveyPopup(false);
  };

  function getBestImageUrl(image: {
    largeUrl?: string;
    mediumUrl?: string;
    smallUrl?: string;
    thumbnailUrl?: string;
  }): string {
    if (!image) return "";

    const urls = [
      image.largeUrl,
      image.mediumUrl,
      image.smallUrl,
      image.thumbnailUrl,
    ];

    const validUrl = urls.find((url) => typeof url === "string" && url.trim() !== "");

    return validUrl || "";
  }

  return (
    <>
      <div>
        <SurveyPopup showPopup={showSurveyPopup} onClose={handleClosePopup} />
      </div>
      <Container>
        <Box my={4}>
          <Slider
            dots={true}
            autoplay={filteredBanners.length !== 1}
            autoplaySpeed={4000}
            infinite={filteredBanners.length !== 1}
            speed={500}
            slidesToShow={1}
            slidesToScroll={1}
          >
            {filteredBanners.map((banner, index) => {
              const imageElement = (
                <img
                  src={getBestImageUrl(banner.image)}
                  alt={`Slide ${index}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: '8px'
                  }}
                />
              );

              return (
                <Box
                  key={index}
                  style={{ position: 'relative', height: '300px', overflow: 'hidden' }}
                >
                  {banner.url ? (
                    banner.url.startsWith('http') ? (
                      <a href={banner.url} target="_blank" rel="noopener noreferrer">
                        {imageElement}
                      </a>
                    ) : (
                      <Link to={banner.url}>{imageElement}</Link>
                    )
                  ) : (
                    imageElement
                  )}
                </Box>
              );
            })}
          </Slider>
        </Box>
        <Box my={2}>
          <Typography variant="h5" style={{ fontWeight: 'bold', fontSize: '1.5rem', textAlign: 'left' }}>
            Acesso rápido
          </Typography>
          <hr style={{ border: '1px solid lightgray', margin: '24px 0 36px 0' }} />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <Link to={`/panel/schedule-indication${origin}`} style={{ textDecoration: 'none' }}>
                <ButtonBase
                  style={{
                    backgroundColor: '#E9F8FC',
                    borderRadius: 16,
                    padding: '16px 24px',
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'flex-start',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                  }}
                >
                  <Box
                    style={{
                      backgroundColor: '#89DAF1',
                      padding: 12,
                      borderRadius: 12,
                      marginRight: 16,
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <AccountHeartOutline style={{ color: 'white', fontSize: 28 }} />
                  </Box>
                  <Box textAlign="left">
                    <Typography variant="subtitle1" style={{ fontWeight: 500, color: 'black' }}>
                      Consulta com os especialistas
                    </Typography>
                  </Box>
                </ButtonBase>
              </Link>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Link to={`/panel/discounts${origin}`} style={{ textDecoration: 'none' }}>
                <ButtonBase
                  style={{
                    backgroundColor: '#DFFBEF',
                    borderRadius: 16,
                    padding: '16px 24px',
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'flex-start',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                  }}
                >
                  <Box
                    style={{
                      backgroundColor: '#00C851',
                      padding: 12,
                      borderRadius: 12,
                      marginRight: 16,
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <TicketPercentOutline style={{ color: 'white', fontSize: 28 }} />
                  </Box>
                  <Box textAlign="left">
                    <Typography variant="subtitle1" style={{ fontWeight: 500, color: 'black' }}>
                      Descontos
                    </Typography>
                  </Box>
                </ButtonBase>
              </Link>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Link to={`/panel/regulation${origin}`} style={{ textDecoration: 'none' }}>
                <ButtonBase
                  style={{
                    backgroundColor: '#FEEAE5',
                    borderRadius: 16,
                    padding: '16px 24px',
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'flex-start',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                  }}
                >
                  <Box
                    style={{
                      backgroundColor: '#F96B46',
                      padding: 12,
                      borderRadius: 12,
                      marginRight: 16,
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <ShieldSearch style={{ color: 'white', fontSize: 28 }} />
                  </Box>
                  <Box textAlign="left">
                    <Typography variant="subtitle1" style={{ fontWeight: 500, color: 'black' }}>
                      Eventos e Regulamentações
                    </Typography>
                  </Box>
                </ButtonBase>
              </Link>
            </Grid>
          </Grid>
        </Box>

        <Box my={4} py={3}>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <Typography variant="h1" style={{ fontWeight: 'bold', fontSize: '1.5rem', textAlign: 'left' }}>
                Conteúdos
              </Typography>
            </Grid>
            <Grid item>
              <Link to={`/panel/contents${origin}`} style={{ textDecoration: 'none' }}>
                <Typography variant="body2" style={{ color: 'var(--primary-main)', cursor: 'pointer' }}>
                  Exibir mais
                </Typography>
              </Link>
            </Grid>
          </Grid>

          {/* Campo de busca e filtro de categorias */}
          <Box
            display="flex"
            flexDirection={isSmallScreen ? 'column' : 'row'}
            justifyContent="space-between"
            alignItems="center"
            my={2}
          >
            <TextField
              placeholder="Busque e explore nosso banco de conteúdos"
              variant="outlined"
              value={searchTerm}
              onChange={handleSearchChange}
              style={{
                backgroundColor: '#fff',
                width: isSmallScreen ? '100%' : '70%',
                marginBottom: isSmallScreen ? theme.spacing(2) : 0
              }}
              InputProps={{
                startAdornment: (
                  <Box>
                    <SearchOutlined />
                  </Box>
                ),
                style: { fontSize: isSmallScreen ? '0.9rem' : '1rem' },
              }}
            />
              <Select
                value={selectedCategory}
                onChange={handleCategoryChange}
                variant="outlined"
                style={{
                  width: isSmallScreen ? '100%' : '28%',
                  fontSize: isSmallScreen ? '0.9rem' : '1rem',
                }}
              >
              <MenuItem key="all" value="Todas as categorias">
                <Typography variant="body2">Todas as categorias</Typography>
              </MenuItem>
              {filteredCategories.map((category) => (
                <MenuItem key={category.id} value={category.name}>
                  <Typography variant="body2">{category.name}</Typography>
                </MenuItem>
              ))}
            </Select>
          </Box>

          {/* Verificação de resultados */}
          {filteredNews.length === 0 ? (
            <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
              <SentimentDissatisfied style={{ fontSize: '3rem', color: 'gray' }} />
              <Typography variant="h6" style={{ textAlign: 'center', color: 'gray', marginTop: '10px' }}>
                Nenhum conteúdo encontrado para os filtros selecionados.
              </Typography>
              <Typography variant="body2" style={{ textAlign: 'center', color: 'gray', marginTop: '5px' }}>
                Tente ajustar sua pesquisa ou explorar outras categorias.
              </Typography>
            </Box>
          ) : (
            <Grid container spacing={4}>
              {filteredNews.map((news, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Box className={classes.cardContainer}>
                    {/* Imagem do Card com efeito de zoom */}
                    <Box className={classes.imageBox}>
                      <img
                        src={getBestImageUrl(news.image)}
                        alt={news.title}
                        className={classes.image}
                        loading='lazy'
                      />
                  </Box>
                  {/* Conteúdo do Card */}
                  <Box style={{ padding: '16px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                    {/* Exibição das Categorias */}
                    <Box mb={1} display="flex" flexWrap="wrap">
                      {news.tags.map((tag) => (
                        <Chip
                          key={tag.id}
                          label={tag.name}
                          style={{
                            backgroundColor: tag.color || '#ddd',
                            color: '#333',
                            fontWeight: 'bold',
                            fontSize: '0.65rem',
                            textTransform: 'uppercase',
                            marginRight: '4px',
                            marginBottom: '4px'
                          }}
                          size="small"
                        />
                      ))}
                    </Box>
                    <ButtonBase
                      key={news.title}
                      onClick={() => handleClick(news)}
                      className={classes.buttonBaseContainer}
                    >
                      <Typography variant="body1" className={classes.title}>
                        {news.title}
                      </Typography>
                      <Typography variant="body2" className={classes.content}>
                        {news.description}
                        <span>{' '}</span>
                        <a href="#" onClick={(e) => e.preventDefault()}>Saiba mais</a>
                      </Typography>
                    </ButtonBase>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        )}
        </Box>
      </Container>
    </>
  );
};

export default DashboardPage;
